export const workshop = {
  management: {
    organisation: 'Organisation',
    project: 'Project',
    allProjects: 'All projects',
    selectOrganisation: 'Please select an organisation to view workshops and facilitator availability.',
    linkProject: 'Linked project',
    linkProjectHint:
      'Optional. Choose the org project this workshop belongs to (budget tracker / project timeline), for example Awe & Wander or MMUH — not an Overhear app map.',
    noLinkedProject: 'No project',
    projectColumn: 'Project',
  },
  booking: {
    submitButton: "Submit Booking Request",
    submitting: "Submitting...",
    title: "Book a Custom Workshop",
    subtitle: "Request an OVERHEAR workshop tailored for your organisation",
    features: {
      audioStorytelling: "🎙️ Audio Storytelling",
      creativeWriting: "✍️ Creative Writing",
      heritagePreservation: "🏛️ Heritage Preservation"
    },
    steps: {
      organisationDetails: "Organisation Details",
      workshopPreferences: "Workshop Preferences",
      contactInformation: "Contact Information",
      reviewSubmit: "Review & Submit"
    },
    organisation: {
      title: "Tell us about your organisation",
      nameLabel: "Organisation Name *",
      namePlaceholder: "e.g., Riverside Community Centre, Heritage Museum",
      typeLabel: "Organisation Type *",
      typePlaceholder: "e.g., Community Centre, Library, Museum, Cultural Centre, Care Home, Youth Organisation, etc.",
      participantCountLabel: "Expected number of participants: {{count}}",
      participantCountHelper: "Small groups (3-8) allow for more personalised attention. Maximum group size is 12 participants.",
      participantRangeLabel: "Expected participants: {{range}}",
      participantRangeHelper: "Drag the two handles to set a minimum and a maximum. Small groups (3–8) allow for more personalised attention. The largest group we can take is 12."
    },
    preferences: {
      title: "Workshop preferences",
      durationLabel: "Workshop Duration",
      duration90Mins: "90 mins - Light activity",
      duration2Hours: "2 hours - Introduction",
      duration3Hours: "3 hours - Standard (Recommended)",
      duration4Hours: "4 hours - Comprehensive",
      durationHelper: "Duration includes creative exercises, audio recording practice, and sharing",
      datePickerLabel: "Add Preferred Date",
      datePickerHelper: "Select dates that work for your group",
      timePreferenceTitle: "Time of Day Preference",
      timeMorning: "Morning (9am-12pm)",
      timeAfternoon: "Afternoon (12pm-5pm)",
      timeEvening: "Evening (5pm-8pm)",
      timeNoPreference: "No preference",
      timePreferenceHelper: "Select your preferred times or choose 'No preference' for maximum flexibility",
      preferredDatesTitle: "Preferred Dates ({{count}}/3 recommended)",
      preferredDatesDescription: "Select multiple dates to give us more scheduling options",
      dateLabel: "Date {{index}}",
      dateSelectPlaceholder: "Select a date",
      dateEmptyInfo: "Please select at least one preferred date. Having multiple options (2-3 dates recommended) helps us find the best time for your workshop.",
      dateOneWarning: "Great start! Consider adding 1-2 more dates to give us more flexibility in scheduling your workshop.",
      dateThreeSuccess: "Perfect! Having multiple date options helps us accommodate your schedule more easily.",
      venueTitle: "Where will the workshop take place?",
      venueTheirPremises: "On our premises",
      venueElsewhere: "Elsewhere (we'll arrange a venue together)",
      venueUnsure: "Not sure yet",
      venueHelper: "If the workshop is at your organisation, tell us which room we'll use.",
      roomLabel: "Room we'll be using",
      roomPlaceholder: "e.g. Meeting Room 3, Library, Main Hall",
      roomHelper: "Optional — leave blank if the room isn't confirmed yet.",
      notesLabel: "Tell us about your group",
      notesPlaceholder: "Describe your group (who they are, ages or background if relevant) and any additional requirements such as accessibility needs, topics to focus on, or special considerations...",
      notesHelper: "Help us tailor the workshop — include who the group is and any requirements we should know about."
    },
    suggestions: {
      title: "Which workshop formats would work well?",
      description: "Select any that feel like a good fit for your group — we can combine formats or adapt them with you.",
      helper: "Tick the formats that sound useful. If none of them fit, choose the last option and tell us about the group in your notes.",
      learnMore: "Learn more",
      "noticing-walk": {
        title: "Noticing Walk",
        description: "A simple noticing walk where participants hold up physical frames to look at their environment through, with prompts on the frames."
      },
      "story-sharing": {
        title: "Story Sharing Session",
        description: "We facilitate listening to a group's stories on a theme — structured sharing and attentive listening together."
      },
      "qr-workshop": {
        title: "QR Workshop Session",
        description: "A session that uses the OVERHEAR app more fully — QR-led workshop activities for the group."
      },
      "listening-moment": {
        title: "Listening Moment",
        description: "A seated session. The group listens together — to the place, or to a short poem — then responds through structured peer-to-peer feedback: a moment alone, a conversation in pairs, then a small group, before anything is offered to the room. No walk and no phone needed."
      },
      "none-of-these": {
        title: "None of these quite fit — talk to us",
        description: "Tell us about the group in your notes and we will shape a session with you."
      }
    },
    contact: {
      title: "Contact information",
      nameLabel: "Contact Name",
      emailLabel: "Contact Email",
      phoneLabel: "Contact Phone",
      phonePlaceholder: "Optional — add this if you would like a call, a text, or WhatsApp",
      phoneRequiredPlaceholder: "Needed so we can call, text, or message you on WhatsApp",
      methodTitle: "How would you like us to get in touch?",
      methodHelper: "Tick every option that works. We still use your email for the booking record.",
      methodEmail: "Email",
      methodPhone: "Phone call",
      methodWhatsapp: "WhatsApp",
      methodText: "Text message"
    },
    review: {
      title: "Review your booking request",
      timePreferences: "Time Preferences:",
      noPreference: "No preference (flexible)",
      preferredDates: "Preferred Dates:",
      workshopFormats: "Workshop formats:",
      venue: "Venue:",
      venueTheirPremises: "On your premises",
      venueElsewhere: "Elsewhere",
      venueUnsure: "Not sure yet",
      room: "Room: {{room}}",
      contact: "Contact: {{name}}",
      contactMethods: "Preferred contact:",
      additionalNotes: "About your group:",
      nextStepsTitle: "What happens next:",
      nextSteps1: "Our team will review your request within 2-3 business days",
      nextSteps2: "We'll contact you to confirm dates and discuss specific requirements",
      nextSteps3: "Once confirmed, we'll send detailed workshop information and preparation materials"
    },
    success: {
      title: "Booking Request Submitted!",
      message: "Thank you for your workshop booking request! Our team will review your requirements and contact you within 2-3 business days to arrange your custom Heritage Audio/Creative Writing workshop.",
      reference: "Reference: {{organisationName}} - {{timestamp}}",
      bookAnother: "Book Another Workshop",
      returnHome: "Return Home"
    },
    help: {
      title: "Need Help?",
      description: "If you're having trouble with this form or have questions about our workshops, please contact us directly for assistance.",
      contactUs: "Contact Us"
    },
    error: {
      submitFailed: "Failed to submit workshop booking request. Please try again."
    }
  },
  validation: {
    organisationNameRequired: "Organisation name is required",
    organisationTypeRequired: "Organisation type is required",
    minimumParticipants: "Minimum group size is 3 participants",
    participantRangeInvalid: "Choose a participant range between 3 and 12",
    selectPreferredDate: "Please select at least one preferred date",
    venueTypeRequired: "Please tell us where the workshop will take place",
    groupDescriptionRequired: "Please tell us about your group",
    workshopSuggestionRequired: "Please select at least one workshop format that would work well",
    contactNameRequired: "Please enter contact name",
    contactEmailRequired: "Please enter contact email",
    contactMethodRequired: "Please choose at least one way for us to get in touch",
    contactPhoneRequired: "Add a phone number so we can call, text, or message you on WhatsApp",
    privacyConsentRequired: "Please accept the privacy policy to continue"
  },
  delete: {
    emailLog: {
      title: "Delete Email Log",
      message: "Are you sure you want to delete this email log entry? This action cannot be undone.",
      bulkTitle: "Delete Selected Email Logs",
      bulkMessage: "Are you sure you want to delete {{count}} email log entries? This action cannot be undone."
    }
  },
  datePoll: {
    tabTitle: "Facilitator Date Polls",
    tabDescription: "Invite facilitators to mark their availability across proposed dates and find when everyone is free. You can also record or update any answer after a phone call.",
    createPoll: "New date poll",
    createTitle: "Create facilitator date poll",
    createDescription: "Propose several dates and invite facilitators to indicate when they can run the workshop together.",
    pollTitle: "Poll title",
    pollDescription: "Description (optional)",
    selectFacilitators: "Invite facilitators",
    proposedDates: "Proposed dates",
    addDate: "Add date",
    dateRangeTitle: "Add a date range",
    dateRangeDescription: "Select a start and end date, then choose which morning, afternoon, or evening slots to add for each day.",
    rangeStart: "From",
    rangeEnd: "To",
    addDateRange: "Add dates in range",
    rangeAdded: "Added {{count}} date(s) from the range.",
    rangeSkippedDuplicates: "{{count}} date(s) were already in the list.",
    rangeAllDuplicates: "All dates in that range are already in the list.",
    individualDates: "Individual dates",
    dateCount: "{{count}} proposed date(s)",
    dateLabel: "Date",
    timeOfDay: "Time of day",
    timeOfDayMorning: "Morning (8am–12pm)",
    timeOfDayAfternoon: "Afternoon (12pm–5pm)",
    timeOfDayEvening: "Evening (5pm–9pm)",
    selectTimeSlots: "Time slots to include",
    startTime: "Start",
    endTime: "End",
    createAndSend: "Create & send invites",
    dateTime: "Date & time",
    summary: "Summary",
    allAvailable: "Everyone is available",
    available: "available",
    pending: "pending",
    resultsHint: "Dates highlighted in green are when all invited facilitators are available.",
    manualUpdateHint: "Click any Yes, Maybe, No, or pending cell to update it after a phone call. Use the edit icon next to a name to record their full response.",
    clickToUpdate: "Click to update",
    enterResponse: "Enter response for {{name}}",
    editResponse: "Edit response for {{name}}",
    recordAvailability: "Record availability",
    recordOnBehalfTitle: "Record availability for {{name}}",
    recordOnBehalfBanner: "Record or update {{name}}'s availability after a phone call or conversation. This is saved as their poll response.",
    availabilityUpdated: "Availability updated.",
    clearEntry: "Clear",
    pendingLabel: "Pending",
    selectOrganisation: "Please select an organisation to manage date polls.",
    emptyState: "No date polls yet. Create one to start aligning facilitator availability.",
    bestMatchCount: "{{count}} best match(es)",
    bestDatesFound: "Best matching dates",
    copyLink: "Copy link",
    remindPending: "Remind pending",
    closePoll: "Close poll",
    deletePoll: "Delete poll",
    deletePollTitle: "Delete date poll",
    deletePollMessage: "Are you sure you want to delete this poll? All facilitator responses will be permanently removed.",
    deletedSuccess: "Date poll deleted.",
    statusClosed: "Closed",
    viewPoll: "View poll",
    previewBeforeSend: "Preview how facilitators will see this poll before sending invites.",
    previewNeedsDates: "Add at least one complete date to preview the poll.",
    noEmailOnFile: "No email",
    noEmailWarning: "{{count}} selected facilitator(s) have no email on file. Enter an address below to send this poll invite.",
    oneOffEmailLabel: "Email for this poll",
    oneOffEmailHelper: "Used only to send this invite — not saved to their profile.",
    previewTitle: "Poll preview",
    previewBanner: "Preview only — this is how invited facilitators will see the poll. Responses cannot be submitted from here.",
    invitedFacilitators: "Invited facilitators",
    createdSuccess: "Date poll created and invitations sent.",
    linkCopied: "Poll link copied to clipboard.",
    remindersSent: "Reminders sent to facilitators who have not responded.",
    closedSuccess: "Date poll closed.",
    loading: "Loading date poll...",
    responseInstructions: "Mark each proposed date and time slot as Yes, Maybe, or No. We'll highlight slots when everyone can make it.",
    yes: "Yes",
    maybe: "Maybe",
    no: "No",
    notes: "Notes (optional)",
    submitting: "Submitting...",
    submitResponse: "Submit availability",
    updateResponse: "Update availability",
    alreadyResponded: "You have already responded. You can change your answers below while this poll is still open.",
    responseSaved: "Your availability has been saved.",
    thankYou: "Thank you — your availability has been recorded. The workshop team will be in touch once a date is confirmed.",
    loginRequired: "Please sign in with your facilitator account to respond to this poll.",
    validation: {
      titleRequired: "Please enter a poll title.",
      minFacilitators: "Please invite at least two facilitators.",
      minDates: "Please add at least one proposed date.",
      incompleteDates: "Please complete all date and time slot fields.",
      selectTimeSlot: "Please select at least one time slot for the date range.",
      answerAllDates: "Please respond to every proposed date.",
      invalidRange: "Please enter a valid start and end date.",
      rangeTooLong: "Date ranges cannot exceed {{max}} days. Add a shorter range or add dates individually.",
      missingOneOffEmail: "Enter an email for each facilitator without one on file.",
      invalidOneOffEmail: "Please enter a valid email address for {{name}}."
    },
    errors: {
      loadFailed: "Failed to load date polls.",
      noPollId: "No poll ID provided.",
      notFound: "This date poll could not be found.",
      closed: "This date poll is no longer accepting responses.",
      notInvited: "You are not invited to this date poll.",
      updateFailed: "Failed to update availability."
    },
    facilitator: {
      pendingTitle: "Date polls awaiting your response",
      pendingDescription: "Help us find a workshop date by marking when you are available.",
      pendingCount: "{{count}} pending",
      respond: "Respond",
      updateResponse: "Update response",
      respondedTitle: "Date polls you have responded to",
      respondedDescription: "You can still change your availability while these polls are open.",
      dateOptionsCount: "{{count}} proposed dates",
      emptyInTab: "No date polls need your response right now."
    }
  }
}
